import React from 'react'
import Heading from '../../Luxkit/Typography/Heading'
import useToggle from 'hooks/useToggle'
import TextLink from '../../Luxkit/TextLink'
import LayoutContainer from '../../Common/LayoutContainer'
import FaqStructuredData from './FaqStructuredData'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Accordion from 'components/Luxkit/Accordion'
import { take } from 'lib/array/arrayUtils'
import SlideDown from 'components/utils/SlideDown'

interface Props {
  heading: string;
  items: Array<App.QuestionAndAnswer>;
  maxToShow?: number;
  size?: 'sm' | 'lg';
}

function FrequentlyAskedQuestions({
  heading,
  items,
  maxToShow,
  size,
}: Props) {
  const [isExpanded, toggleIsExpanded] = useToggle()
  const hasExtrasToExpand = items.length > maxToShow

  return (
    <LayoutContainer size="md">
      <VerticalSpacer gap={16}>
        <FaqStructuredData items={items} />
        {heading && <Heading as="h3" variant="heading3" align="center">{heading}</Heading>}
        <div>
          {take(items, maxToShow).map((item) => (
            <Accordion
              key={item.question}
              size={size == 'sm' ? 'small' : 'large'}
              heading={item.question}
            >
              <MarkdownRender content={item.answer} />
            </Accordion>
          ))}
          {hasExtrasToExpand && <SlideDown show={isExpanded}>
            <div>
              {take(items, items.length, maxToShow).map((item) => (
                <Accordion
                  key={item.question}
                  size={size == 'sm' ? 'small' : 'large'}
                  heading={item.question}
                >
                  <MarkdownRender content={item.answer} />
                </Accordion>
              ))}
            </div>
          </SlideDown>}
        </div>
        {hasExtrasToExpand && (
          <TextLink onClick={toggleIsExpanded}>
            {isExpanded ? 'Show Less' : 'Show More'}
          </TextLink>
        )}
      </VerticalSpacer>
    </LayoutContainer>
  )
}

FrequentlyAskedQuestions.defaultProps = {
  maxToShow: 5,
  size: 'sm',
}

export default FrequentlyAskedQuestions
